// extracted by mini-css-extract-plugin
export var shared = "button-module--shared--2-xdS";
export var content = "button-module--content--3K_EP";
export var largeButton = "button-module--large-button--1O_Md";
export var smallButton = "button-module--small-button--3akoN";
export var circleButton = "button-module--circle-button--1QSOv";
export var textButton = "button-module--text-button--1lVzk";